import { SvgIcon } from "@mui/material";
import React from "react";

function ArchiveIcon(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path d="M4 3.98917C4 3.2585 4.59333 2.6665 5.324 2.6665H26.676C27.0262 2.66894 27.3613 2.80904 27.609 3.05652C27.8568 3.304 27.9972 3.63901 28 3.98917V28.0105C27.9996 28.3614 27.86 28.6978 27.6117 28.9459C27.3635 29.1939 27.0269 29.3332 26.676 29.3332H5.324C4.97384 29.3307 4.63869 29.1906 4.39096 28.9432C4.14322 28.6957 4.00279 28.3607 4 28.0105V3.98917ZM25.3333 14.6665V5.33317H6.66667V14.6665H25.3333ZM25.3333 17.3332H6.66667V26.6665H25.3333V17.3332ZM12 7.99984H20V10.6665H12V7.99984ZM12 19.9998H20V22.6665H12V19.9998Z" />
    </SvgIcon>
  );
}

export default ArchiveIcon;
